import toast from 'react-hot-toast';
import api from "../Crypto/axios.js";

export const FETCH_ALL_SELLER = 'FETCH_ALL_SELLER';
export const ADD_NEW_SELLER = 'ADD_NEW_SELLER';
export const SET_SELECTED_SELLER = 'SET_SELECTED_SELLER';
export const RESET_SELECTED_SELLER = 'RESET_SELECTED_SELLER';
export const CLEAR_DATA = 'CLEAR_DATA';
export const STATUS_UPDATED = 'STATUS_UPDATED';
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS';
export const SET_DEFAULT_ADDRESS = 'SET_DEFAULT_ADDRESS';

const initialState = {
  allSeller: [],
  newSeller: [],
  selectedSeller: {},
  statusUpdate: {},
  userAddress: {},
  defaultAddress : false
};

const SellerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_SELLER:
      return {
        ...state,
        allSeller: action.payload,
      };
    case ADD_NEW_SELLER:
      return {
        ...state,
        newSeller: action.payload,
      };
    case SET_SELECTED_SELLER:
      return {
        ...state,
        selectedSeller: action.payload,
      };
       case SET_DEFAULT_ADDRESS:
      return {
        ...state,
        defaultAddress: action.payload,
      };
    case RESET_SELECTED_SELLER:
      return {
        ...state,
        selectedSeller: {},
      };
    case STATUS_UPDATED:
      return {
        ...state,
        statusUpdate: {},
      };
    case SET_USER_ADDRESS:
      return {
        ...state,
        userAddress: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...state,
        selectedSeller: {},
        error: null,
      };
    default:
      return state;
  }
};

export default SellerReducer;

export const fetchAllSeller = (data) => ({
  type: FETCH_ALL_SELLER,
  payload: data,
});
export const addSeller = (data) => ({
  type: ADD_NEW_SELLER,
  payload: data,
});
export const clearData = () => ({
  type: CLEAR_DATA,
});
export const setSelectedSeller = (data) => ({
  type: SET_SELECTED_SELLER,
  payload: data,
});
export const setUserAddress = (data) => ({
  type: SET_USER_ADDRESS,
  payload: data,
});
export const setDefaultAddress = (data) => ({
  type: SET_DEFAULT_ADDRESS,
  payload: data,
});
export const resetSelectedSeller = () => ({
  type: RESET_SELECTED_SELLER,
});
export const statusUpdate = (data) => ({
  type: STATUS_UPDATED,
});


export const getAllSeller = (userId) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/seller/${userId}`, { requiresAuth: true })
      .then((response) => {
        dispatch(fetchAllSeller(response));
        return response;
      });
    return promise.catch(() => {
      return { status: 'error', message: 'Failed to fetch sellers' };
    });
  };
};

export const getSellerById = (sellerId, adminId) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/oneseller/${sellerId}/${adminId}`, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(setSelectedSeller(response));
        return response;
      });
    return promise.catch(() => {
      return { status: 'error', message: 'Failed to fetch seller' };
    });
  };
};

export const addNewSeller = (adminId, newSeller) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/new/seller/${adminId}`, newSeller, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(addSeller(response.seller));
        return response;
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message;

        if (error?.response?.status === 403) {
          toast.error(
            'Permission denied. Only an admin can create another seller.'
          );
        } else if (error?.response?.status === 400) {
          if (errorMessage === 'Passwords do not match.') {
            toast.error('Passwords do not match.');
          } else if (errorMessage === 'Seller with this email already exists') {
            toast.error('Seller with this email already exists.');
          } else {
            toast.error('Invalid seller data');
          }
        }

        console.error('Failed to add seller:', error);
        throw new Error(errorMessage || 'Failed to add seller');
      });

    toast.promise(promise, {
      loading: 'Adding new seller...',
      success: 'New Seller Added successfully',
      error: (error) => {
        return error.response?.data?.message || 'Failed to add seller';
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to add seller' };
    });
  };
};

export const editSeller = (adminId, sellerData) => {
  return async (dispatch) => {
    const promise = fetch(
      `${process.env.REACT_APP_API_URL}/nrcb/ecom/edit/seller/${adminId}`,
      {
        method: 'POST',
        body: JSON.stringify(sellerData),
        headers: { 'Content-Type': 'application/json' },
      }
    )
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json();
          const errorMessage = errorData.message || 'Failed';
          throw new Error(errorMessage);
        }
        const val = await response.json();
        dispatch(addSeller(val));
        return val;
      })
      .catch((error) => {
        console.error('Error in edit registration:', error);
        throw error;
      });

    toast.promise(promise, {
      loading: 'Editing data...',
      success: 'Successfully Edited',
      error: 'Failed to edit data',
    });

    return promise;
  };
};

export const statusSeller = (data, adminId) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/status/seller/${adminId}`, data, { requiresAuth: true })
      .then((response) => {
        dispatch(statusUpdate(response));
        return response;
      });

    toast.promise(promise, {
      loading: 'Editing data...',
      success: 'Successfully Edited',
      error: (error) => {
        console.error('Failed to edit data:', error);
        return error.response?.data?.message || 'Failed to edit data';
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to edit data' };
    });
  };
};

export const getAddressById = (id) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/address/${id}`, { requiresAuth: true })
      .then((response) => {
        dispatch(setUserAddress(response));
        if(response.address.length>0){
        dispatch(setDefaultAddress(true))
        }
        return response;
      })
      .catch((error) => {
        dispatch(clearData());
        console.error('Failed to fetch seller:', error);
        throw new Error(error.message || 'Failed to get seller');
      });
    return promise;
  };
};

export const addNewAddress = (userId, address) => {
  return async (dispatch) => {
    const promise = api.post(`/nrcb/ecom/add/address/${userId}`, address, { requiresAuth: true })
      .then((response) => {
        dispatch(statusUpdate()); 
        toast.success('Address added successfully');
        return response;
      })
      .catch((error) => {
        dispatch(clearData()); 
        console.error('Failed to add address:', error);
        throw new Error(error.message || 'Failed to add address');
      });

    toast.promise(promise, {
      loading: 'Adding address...',
      success: () => 'Address added successfully',
      error: (error) => error.message || 'Failed to add address',
    });

    return promise;
  };
};

export const editNewAddress = (userId, address) => {
  return async (dispatch) => {
    const promise = api.post(`/nrcb/ecom/update/seller/address/${userId}`, address,{requiresAuth:true})
      .then((response) => {
        dispatch(statusUpdate());
        return response;
      })
      .catch((error) => {
        console.error('Error in edit:', error);
        throw new Error(error.message || 'Failed');
      });

    toast.promise(promise, {
      loading: 'Updating address...',
      success: 'Edited successfully',
      error: (error) => error.message || 'Failed to edit address',
    });

    return promise;
  };
};


export const setCurrentAddress = (userId, addressId) => {
  return async (dispatch) => {
    const promise = api.post(`/nrcb/ecom/set/current/address/${userId}/${addressId}`,{},{requiresAuth:true})
      .then((response) => {
        dispatch(statusUpdate());
        return response;
      })
      .catch((error) => {
        console.error('Error in set current address:', error);
        throw new Error(error.message || 'Failed');
      });

    toast.promise(promise, {
      loading: 'Setting current address...',
      success: 'Current address set successfully',
      error: (error) => error.message || 'Failed',
    });

    return promise;
  };
};
